<template>
  <div>
    <div id="chat-options" class="d-flex align-end justify-center px-2 py-1 text-field">
      <div
        v-if="$organization.allowEmojisForWidgetChat()"
        id="emojis"
      >
        <button
          @click="toggleDropdown('dropdow-emojis')"
          class="btn btn-light p-2 px-2 rounded-0 option"
        >
          <img class="mt-2" src="/images/happy.svg" alt="">
        </button>
        <div class="drop-container shadow text-left" id="dropdow-emojis">
          <div class="header d-flex align-items-center">
            <div class="flex-fill px-3 my-1 mx-1">
              <small><b>{{$t('chat.emojis')}}</b></small>
            </div>
            <button
              class="btn btn-light border-0 font-weight-bold close"
              @click="toggleDropdown('dropdow-emojis')"
            >
              <b>
                <Icon
                  class="my-1 mx-1"
                  :width="20"
                  :height="20"
                  :icon="'close'"
                />
              </b>
            </button>
          </div>
          <div class="body text-center p-2">
            <Emojis @select="setEmoji" />
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <Clipboard
          v-if="attachments"
          ref="clipboard"
          @addFiles="addFiles"
          @setAttachments="setAttachments"
          @updateLoading="updateLoading"
        />
        <v-text-field
          type="text"
          :placeholder="$t('chat.textField.placeHolnder')"
          v-model="message"
          filled
          dense
          rounded
          hide-details
          color="primary"
          v-on:keyup.enter="send()"
          v-on:paste.native="pasteFile"
          :disabled="uploading"
          focus
        ></v-text-field>
      </div>
      <v-slide-x-transition>
        <v-btn
          class="ml-1"
          fab
          small
          color="transparent"
          elevation="0"
          @click="send()"
          v-if="message || files.length > 0"
          :loading="uploading"
        >
          <Icon
            :width="24"
            :icon="'send'"
          />
        </v-btn>
        <v-btn
          class="ml-1"
          fab
          small
          color="transparent"
          elevation="0"
          v-else-if="$organization.allowUserShareFiles() && !message && attachments"
          @click="showAttachments"
        >
          <Icon
            :width="19"
            :height="19"
            :icon="'paperclip'"
          />
        </v-btn>
      </v-slide-x-transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    Emojis: () => import(/* webpackPrefetch: true */ '@/components/Emojis.vue'),
    Clipboard: () => import(/* webpackPrefetch: true */  './Clipboard.vue')
  },
  props: {
    attachments: {
      type: Boolean,
      default: true
    }
  }
})
export default class TextField extends Vue {
  data () {
    return {
      message: '',
      files: [],
      uploading: false
    }
  }

  updateLoading (value) {
    this.uploading = value
  }

  setAttachments (filesSent) {
    for (let i = 0; i < filesSent.length; i++) {
      this.$emit('sendAttachmentClipBoard', filesSent[i])
    }

    this.uploading = false
  }

  addFiles (files) {
    this.files = files
  }

  pasteFile (event) {
    this.$refs.clipboard.pasteFile(event)
  }

  send () {
    if (this.$organization.allowEmojisForWidgetChat()) {
      this.toggleDropdown('dropdow-emojis', true)
    }

    if (this.files.length > 0) {
      this.uploading = true
      this.$refs.clipboard.sendFile()
    }

    this.$emit('sendMessage', this.message, 'message')
    this.message = ''
  }

  showAttachments () {
    this.$emit('showAttachments')
  }

  setEmoji (emoji) {
    this.message += emoji
  }

  toggleDropdown (dropdown, remove) {
    if (remove) {
      this.$el.querySelector(`#${dropdown}.drop-container`).classList.remove('active')
    } else {
      this.$el.querySelector(`#${dropdown}.drop-container`).classList.toggle('active')
    }
  }
}
</script>

<style>
#chat-options .v-input__control .v-input__slot {
  background: white !important;
  padding: 7px !important;
}

#chat-options button.option {
  border: 0 !important;
  border-right: 1px solid #E6E6E6 !important;
  opacity: .7;
  transition: all .2s;
}

#chat-options button.btn:hover {
  opacity: 1;
}

#chat-options button.btn:focus {
  background-color: transparent;
}

#chat-options button.btn img {
  width: 20px;
}

.drop-container {
  transition: all .2;
  position: absolute;
  background-color: white;
  border: 1px solid #E6E6E6;
  width: 300px;
  bottom: 50px;
  left: 5px;
  border-radius: 5px;
  visibility: hidden;
  z-index: 999;
}

.drop-container .body {
  height: 300px;
  overflow: auto;
}

.drop-container.active {
  bottom: 60px;
  visibility: visible;
}

#emojis button.emoji {
  width: 35px;
  height: 35px;
  margin: 5px;
  border: 0 !important;
}
</style>
